// src/Components/Charts/ChartStyles.js

// 🎨 ===== Color Palette =====
export const chartColors = {
  primary: "#4361EE",     // Accent blue
  secondary: "#4CC9F0",   // Light blue
  accent: "#F3722C",      // Orange highlight
  success: "#1DBF73",     // Positive indicators
  danger: "#D9534F",      // Negative indicators
  neutral: "#6C757D",     // Subtle text
  background: "#FFFFFF",
  grid: "#E9ECEF",
};

// 🧭 ===== Font & Layout Tokens =====
export const chartFonts = {
  family: "'Inter', sans-serif",
  sizeSmall: "0.8rem",
  sizeLabel: "0.7rem",
  weightNormal: 400,
  weightBold: 600,
};

// 💬 ===== Tooltip Styles =====
export const tooltipContentStyle = {
  backgroundColor: "rgba(255, 255, 255, 0.8)", // semi-transparent white
  border: "none",
  borderRadius: "8px",
  boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.05)",
  padding: "6px 10px",
  backdropFilter: "blur(4px)", // subtle blur for polish
};

export const tooltipItemStyle = {
  color: chartColors.neutral,
  fontFamily: chartFonts.family,
  fontSize: chartFonts.sizeSmall,
  fontWeight: chartFonts.weightNormal,
};

export const tooltipLabelStyle = {
  color: chartColors.neutral,
  fontFamily: chartFonts.family,
  fontSize: chartFonts.sizeLabel,
  fontWeight: chartFonts.weightNormal,
};

// 📊 ===== Common Chart Configurations =====
export const defaultGridStyle = {
  stroke: chartColors.grid,
  strokeDasharray: "3 3",
};

export const defaultLineProps = {
  type: "monotone",
  strokeWidth: 3,
  dot: false,
  isAnimationActive: false,
};

export const defaultBarProps = {
  radius: [4, 4, 0, 0],
  isAnimationActive: false,
  cursor: "pointer",
};
